import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  useAuth,
  BaseButton,
  useLoginRequiredModal,
  useT,
} from '@repo/common';
import HeroBanner from '../../components/Career/Default/HeroBanner';
import DetailSidebarWhiteBanner from '../../components/JobBoard/Detail/Sidebar/DetailSidebarWhiteBanner';
import DetailSidebarBlackBanner from '../../components/JobBoard/Detail/Sidebar/DetailSidebarBlackBanner';

const CareerResumeGuide = () => {
  const t = useT();
  const guideDesktopImage = `${process.env.REACT_APP_ASSETS_URL}/Career/img-resume-guide-desktop.svg`;
  const guideDesktopGuestImage = `${process.env.REACT_APP_ASSETS_URL}/Career/img-resume-guide-desktop-guest.svg`;
  const guideMobileImage = `${process.env.REACT_APP_ASSETS_URL}/Career/img-resume-guide-mobile.svg`;
  const guideMobileGuestImage = `${process.env.REACT_APP_ASSETS_URL}/Career/img-resume-guide-mobile-guest.svg`;

  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();
  const { showLoginModal } = useLoginRequiredModal();

  const Banner = useMemo(() => {
    return Math.random() < 0.5 ? (
      <DetailSidebarWhiteBanner />
    ) : (
      <DetailSidebarBlackBanner />
    );
  }, []);

  return (
    <div className='flex flex-col items-center justify-center bg-grayscale-gray01 tabletH:pb-[420px] w-full'>
      <div className='text-left p-4 tabletH:hidden w-full'>
        <span className='typo-b18Strong font-semibold text-green-deep04 inline bg-[linear-gradient(transparent,transparent_60%,rgba(0,158,79,0.4)_60%)] tracking-wide'>
          {t('Resume Guide', '이력서 가이드')}
        </span>
      </div>
      {isLoggedIn ? (
        <div className='flex flex-col items-center justify-center w-full'>
          {/* 데스크탑 */}
          <img
            alt='guideImage'
            src={guideDesktopImage}
            className='hidden tabletH:block'
          />
          {/* 모바일 */}
          <img
            alt='guideImage'
            src={guideMobileImage}
            className='p-4 tabletH:hidden w-full'
          />
          <div className='flex flex-col items-center justify-center text-center gap-8 px-4 pt-10 pb-[320px] tabletH:py-10 tabletH:px-0 w-full'>
            {/* 데스크탑 */}
            <span className='typo-title1 text-text-primary hidden tabletH:block'>
              {t('Ready to build your own?', '이제 직접 만들어 볼까요?')}{' '}
              <br />
              {t(
                'Create your Korean-style resume in minutes',
                '몇 분 만에 한국형 이력서를 완성해 보세요',
              )}
            </span>
            {/* 모바일 */}
            <div className='flex flex-col items-center gap-2 text-text-primary tabletH:hidden'>
              <p className='typo-b20Strong'>
                {t('Ready to build your own?', '이제 직접 만들어 볼까요?')}
              </p>
              <p className='typo-b14Strong'>
                {t(
                  'Create your Korean-style resume in minutes',
                  '몇 분 만에 한국형 이력서를 완성해 보세요',
                )}
              </p>
            </div>
            <BaseButton
              hideIcon
              size='l'
              onClick={() =>
                navigate('/career/resumes/new?source=career_guide_cta')
              }
            >
              {t('Start free on Koready', 'Koready에서 무료로 시작하기')}
            </BaseButton>
          </div>
        </div>
      ) : (
        <div className='flex flex-col items-center justify-center w-full'>
          {/* 데스크탑 */}
          <div className='relative hidden tabletH:block'>
            <img alt='guideImage' src={guideDesktopGuestImage} />
            <div className='absolute bottom-[80px] left-1/2 -translate-x-1/2'>
              <BaseButton
                hideIcon
                size='l'
                onClick={() => showLoginModal('career_guide_cta')}
              >
                {t(
                  "Log in to read more — it's free",
                  '로그인하고 더 보기 — 무료예요',
                )}
              </BaseButton>
            </div>
          </div>
          {/* 모바일 */}
          <div className='relative tabletH:hidden w-full'>
            <img
              alt='guideImage'
              src={guideMobileGuestImage}
              className='px-4 w-full'
            />
            <div className='absolute bottom-[150px] left-1/2 -translate-x-1/2'>
              <BaseButton
                hideIcon
                size='l'
                onClick={() => showLoginModal('career_guide_cta')}
              >
                {t(
                  "Log in to read more — it's free",
                  '로그인하고 더 보기 — 무료예요',
                )}
              </BaseButton>
            </div>
          </div>
          <div className='px-10 pt-[80px] w-full hidden tabletH:block'>
            <HeroBanner />
          </div>
          <div className='px-4 pb-[320px] flex items-center justify-center w-full tabletH:hidden'>
            {Banner}
          </div>
        </div>
      )}
    </div>
  );
};

export default CareerResumeGuide;
